import { STATE_STATUS } from '@mgCommon/constants/constants.js';
import SmsService from '@mgServices/sms.service.js';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: STATE_STATUS.IDLE,
  error: null,
};

export const sendSms = createAsyncThunk(
  'sms/sendSms',
  async ({ smsMessage = null, recipients = null, sender = null }) => {
    const res = await SmsService.sendSms({
      smsMessage,
      recipients,
      sender,
    });
    return res.data;
  }
);

const smsSlice = createSlice({
  name: 'sms',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(sendSms.pending, state => {
        state.status = STATE_STATUS.LOADING;
      })
      .addCase(sendSms.fulfilled, state => {
        state.status = STATE_STATUS.SUCCEEDED;
      })
      .addCase(sendSms.rejected, (state, { error }) => {
        state.status = STATE_STATUS.FAILED;
        state.error = error.message;
      });
  },
});

export default smsSlice.reducer;
